export function columnLabel(title: string, subtitle?: string): string {
  return subtitle ? `${title} (${subtitle})` : title
}
